window.addEventListener('scroll', function(){
  var headerColor = document.getElementById('header-fixed-color');
  headerColor.classList.toggle("hide-header", window.scrollY > 10);
});

// === Variant-specific media filtering for DANSA STOOL ===
(function () {
  const PRODUCT_HANDLE = '/products/dansastool';
  if (!window.location.pathname.includes(PRODUCT_HANDLE)) return;

  const VARIANT_TO_POSITIONS = {
    // M variant → show slides 1,2,3,7,8,9
    '50664849211689': [1, 2, 3, 7, 8, 9],
    // L variant → show slides 4,5,6,7,8,9
    '50664849244457': [4, 5, 6, 7, 8, 9]
  };

  function getCurrentSectionId() {
    const el = document.querySelector('[id^="MainProduct-"]');
    if (!el) return null;
    return (el.id || '').replace('MainProduct-', '');
  }

  function getCurrentVariantId() {
    const input = document.querySelector('.product-variant-id');
    if (input && input.value) return input.value;
    // fallback: query parameter ?variant=ID
    const params = new URLSearchParams(window.location.search);
    if (params.get('variant')) return params.get('variant');
    return null;
  }

  function filterGalleryByPositions(sectionId, allowedPositions) {
    if (!sectionId || !allowedPositions || allowedPositions.length === 0) return;

    const viewerList = document.getElementById(`Slider-Gallery-${sectionId}`);
    const thumbList = document.getElementById(`Slider-Thumbnails-${sectionId}`);

    const applyFilter = (ul) => {
      if (!ul) return;
      const items = Array.from(ul.querySelectorAll(':scope > li'));
      items.forEach((li, idx) => {
        const position = idx + 1; // 1-based
        li.style.display = allowedPositions.includes(position) ? '' : 'none';
      });
    };

    applyFilter(viewerList);
    applyFilter(thumbList);

    // Activate first visible thumbnail to sync the main viewer
    if (thumbList) {
      const firstVisibleBtn = thumbList.querySelector('li[style*="display: "] button, li:not([style]) button');
      if (firstVisibleBtn) {
        firstVisibleBtn.click();
      }
    }
  }

  function applyForCurrentVariant() {
    const sectionId = getCurrentSectionId();
    const variantId = getCurrentVariantId();
    const allowed = VARIANT_TO_POSITIONS[String(variantId)];
    if (!allowed || !sectionId) return;
    filterGalleryByPositions(sectionId, allowed);
  }

  // Initial apply once DOM is ready
  document.addEventListener('DOMContentLoaded', applyForCurrentVariant);

  // React on variant change (theme pubsub), if available
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      // Delay slightly to allow DOM to refresh
      setTimeout(applyForCurrentVariant, 0);
    });
  } else {
    // Fallback: observe change on variant selectors
    document.addEventListener('change', (e) => {
      if (e.target && (e.target.closest('variant-radios') || e.target.closest('variant-selects'))) {
        setTimeout(applyForCurrentVariant, 0);
      }
    });
  }
})();

// === Variant-specific media filtering for DANSA STOOL SET ===
(function () {
  const PRODUCT_HANDLES = ['/products/dansadtoolset', '/products/dansastoolset'];
  if (!PRODUCT_HANDLES.some((h) => window.location.pathname.includes(h))) return;

  const VARIANT_TO_POSITIONS = {
    // ２脚ロゴなし
    '45524788052265': [1, 2, 8, 9, 10, 11, 12, 13, 14, 15],
    // ２脚ロゴあり
    '49061340414249': [1, 2, 8, 9, 10, 11, 12, 13, 14, 15],
    // ３−１脚ロゴなし
    '50665791553833': [3, 4, 8, 9, 10, 11, 12, 13, 14, 15],
    // ３−１脚ロゴあり
    '50665791586601': [3, 4, 8, 9, 10, 11, 12, 13, 14, 15],
    // ３−２脚ロゴなし
    '50665791619369': [5, 8, 9, 10, 11, 12, 13, 14, 15],
    // ３−２脚ロゴあり
    '50665791652137': [5, 8, 9, 10, 11, 12, 13, 14, 15],
    // ４脚ロゴなし
    '50665791684905': [6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    // ４脚ロゴあり
    '50665791717673': [6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
  };

  function getCurrentSectionId() {
    const el = document.querySelector('[id^="MainProduct-"]');
    if (!el) return null;
    return (el.id || '').replace('MainProduct-', '');
  }

  function getCurrentVariantId() {
    const input = document.querySelector('.product-variant-id');
    if (input && input.value) return input.value;
    const params = new URLSearchParams(window.location.search);
    if (params.get('variant')) return params.get('variant');
    return null;
  }

  function filterGalleryByPositions(sectionId, allowedPositions) {
    if (!sectionId || !allowedPositions || allowedPositions.length === 0) return;

    const listIds = [
      `Slider-Gallery-${sectionId}`,
      `Slider-Gallery-${sectionId}-duplicate`,
      `Slider-Thumbnails-${sectionId}`,
      `Slider-Thumbnails-${sectionId}-duplicate`
    ];

    listIds.forEach((listId) => {
      const ul = document.getElementById(listId);
      if (!ul) return;
      const items = Array.from(ul.querySelectorAll(':scope > li'));
      items.forEach((li, idx) => {
        const position = idx + 1; // 1-based
        li.style.display = allowedPositions.includes(position) ? '' : 'none';
      });
    });

    // Sync main viewer using the first visible thumbnail (non-duplicate list preferred)
    const thumbList = document.getElementById(`Slider-Thumbnails-${sectionId}`) || document.getElementById(`Slider-Thumbnails-${sectionId}-duplicate`);
    if (thumbList) {
      const firstVisibleBtn = thumbList.querySelector('li[style*="display: "] button, li:not([style]) button');
      if (firstVisibleBtn) firstVisibleBtn.click();
    }
  }

  function applyForCurrentVariant() {
    const sectionId = getCurrentSectionId();
    const variantId = getCurrentVariantId();
    const allowed = VARIANT_TO_POSITIONS[String(variantId)];
    if (!allowed || !sectionId) return;
    filterGalleryByPositions(sectionId, allowed);
  }

  document.addEventListener('DOMContentLoaded', applyForCurrentVariant);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(applyForCurrentVariant, 0));
  } else {
    document.addEventListener('change', (e) => {
      if (e.target && (e.target.closest('variant-radios') || e.target.closest('variant-selects'))) {
        setTimeout(applyForCurrentVariant, 0);
      }
    });
  }
})();

